import { useDispatch, useSelector } from 'react-redux'
import { ORDER_STATUS } from 'src/components/DeliveryCard/constants'
import {
  dayByDeliveryDateSelector,
  isOrderSkippedSelector,
  orderStatusSelector
} from 'src/components/DeliveryCard/selectors'
import { UnkskiptTrackingData } from 'src/types/tracking-types'
import { orderStatusForTrackingSelector } from 'src/redux/slices/selectedDelivery/selectors'
import { unskipOrder } from 'src/redux-api-bridge'
import { track } from 'src/shared/tracking'
import { toaster } from 'src/utils/toaster'

export function useUnskip(
  deliveryDate: string | undefined,
  trackingData: UnkskiptTrackingData | undefined = undefined
) {
  const dispatch = useDispatch()
  const orderStatus = useSelector(state =>
    orderStatusSelector(state, deliveryDate)
  )
  const delivery = useSelector(state =>
    dayByDeliveryDateSelector(state, deliveryDate)
  )
  const isOrderSkipped = useSelector(state =>
    isOrderSkippedSelector(state, deliveryDate)
  )

  const orderStatusForTracking = useSelector(orderStatusForTrackingSelector)

  async function unskipIfRequired() {
    if (!isOrderSkipped || !delivery) {
      return
    }
    await dispatch(unskipOrder({ date: delivery.date }))
    toaster.success('Your order has been unskipped!')
    if (orderStatus === ORDER_STATUS.PAUSED) {
      track('Subscription Unpaused', {
        unpause_source: 'unskip',
        delivery_date: deliveryDate
      })
    } else {
      const tags = trackingData || {}
      track('Unskip Day', {
        ...tags,
        delivery_date: deliveryDate,
        order_status: orderStatusForTracking
      })
    }
  }

  return {
    unskipIfRequired
  }
}
